<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-30 14:17:36
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchVipRightList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
                v-for="item in COMMON_STATUS"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchVipRightList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="cfgCode" label="代码" min-width="200">
            </el-table-column>
            <el-table-column prop="cfgName" label="名称" min-width="150">
            </el-table-column>
            <el-table-column prop="cfgVal" label="值" min-width="150">
            </el-table-column>
            <el-table-column prop="cfgDescr" label="说明" min-width="180">
            </el-table-column>
            <el-table-column prop="cfgSeq" label="排序"></el-table-column>
            <el-table-column prop="cfgStatus" label="状态" min-width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.cfgStatus"
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="statusShow"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        :title="
        clickType == 'change'
          ? '修改配置信息'
          : clickType == 'addNext'
          ? '新增配置信息'
          : ' 配置信息'
      "
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="480px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-row>
            <el-col :span="23">
              <el-form-item label="值：" prop="cfgVal">
                <el-input
                    clearable
                    placeholder="填写值"
                    v-model="params.cfgVal"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item label="名称：" prop="cfgName">
                <el-input
                    clearable
                    placeholder="配置名称"
                    v-model="params.cfgName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代码：" prop="cfgCode">
                <el-input
                    :disabled="clickType == 'change' ? true : false "
                    clearable
                    placeholder="配置代码"
                    v-model="params.cfgCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23">
              <el-form-item label="排序：" prop="cfgSeq">
                <el-input
                    clearable
                    placeholder="排序序号(只允许数字值)"
                    v-model.number="params.cfgSeq"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="23">
              <el-form-item label="说明：" prop="cfgDescr">

                <el-input type="textarea" :rows="4" placeholder="最长为200个字符" v-model="params.cfgDescr"
                          maxlength="200"></el-input>

              </el-form-item>
            </el-col>

          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";


export default {
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,

      loading1: false, //加载中

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        cfgName: [
          {required: true, message: "请填写名称", trigger: "change"},
          // { max: 10, message: "不超过10个字符" },
        ],
        cfgVal: [{required: true, message: "请填写值", trigger: "change"},],
        cfgCode: [{required: true, message: "请填写代码", trigger: "change"},],
        cfgSeq: [{type: 'number', message: "请填写序号(数字)", trigger: "blur"}]
      }, //表单验证提示

      tableData: [], //二级--列表

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,

    };
  },
  created() {
    this.getVipRightList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.isMoer = true;
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:cfg:query') {
            this.searchShow = true
          }
          if (item.code == 'system:cfg:add') {
            this.addShow = true
          }
          if (item.code == "system:cfg:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:cfg:edit") {
            this.editShow = true
          }
          if (item.code == "system:cfg:status") {
            this.statusShow = false
          }
        })
      }
    },

    SearchVipRightList() {
      this.page.pageNo = 1
      this.getVipRightList()
    },
    /**
     *  get list 配置列表
     */
    async getVipRightList() {
      let http = "/config/list";
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
      this.page.count = resData.page.count;
    },

    //switch状态改变 --接口
    handleSwitch(index) {
      //interface
      this.$put(
          `/config/info/status/${this.tableData[index].cfgCode}`
      ).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;

        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/config/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getVipRightList(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改
              const {data: resData} = await this.$put(
                  `/config/info`,
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getVipRightList(); //重新获取数据
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            } else {
              //菜单分配
            }
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/config/info/${row.cfgCode}`,

            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipRightList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipRightList();
    },

  },
};
</script>
